import { createStore } from 'vuex';
import { IRootState } from './models/root-state.model';
import { RootStateModule } from './root-state.store.module';

const store = createStore<IRootState>(RootStateModule);
export default store;
